import { CheckCircleFilled, CheckOutlined, DownOutlined, EuroOutlined } from "@ant-design/icons";
import { css } from "@linaria/core";
import { Button, type ButtonProps, Dropdown, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useCostDisplay } from "../../context/CostDisplayContext.tsx";

type ButtonVariantType = NonNullable<ButtonProps["variant"]>;

// Invisible check on unselected items keeps the labels aligned.
const uncheckedIcon = css`
  visibility: hidden;
`;

// Split button (Dropdown.Button was removed in antd 6 — Space.Compact is the
// replacement): the main button toggles the price column, the attached arrow
// opens the with/without-VAT selection.
export const RecipeCostControls = () => {
  const { t } = useTranslation();
  const state = useCostDisplay();
  const buttonVariant: ButtonVariantType = "outlined";
  return (
    <Space.Compact>
      <Button
        color="primary"
        icon={state.showPrices ? <CheckCircleFilled /> : <EuroOutlined />}
        onClick={() => state.setShowPrices(!state.showPrices)}
        variant={buttonVariant}
      >
        {t("recipes.showPrices")}
      </Button>
      <Dropdown
        destroyOnHidden
        menu={{
          items: (["without", "with"] as const).map((mode) => ({
            key: mode,
            icon: <CheckOutlined className={state.vatMode === mode ? undefined : uncheckedIcon} />,
            label: t(mode === "with" ? "recipes.withVat" : "recipes.withoutVat"),
          })),
          selectable: true,
          selectedKeys: [state.vatMode],
          onClick: ({ key }) => state.setVatMode(key === "with" ? "with" : "without"),
        }}
      >
        <Button color="primary" icon={<DownOutlined />} variant={buttonVariant} />
      </Dropdown>
    </Space.Compact>
  );
};
